import Translation from "../../Translation/cont/Translation"
import Button from "../../general/Button"
import OverlayWrapper from "./OverlayWrapper"

const OverlayTwoActionsComponent = ({
    titleTransId,
    textTransId,
    textBefore = '',
    primaryButtonTransId,
    onPrimary,
    secondaryButtonTransId,
    onSecondary
}) => (
    <OverlayWrapper>
        <div className='title-large-color text'><Translation id={titleTransId}/></div>
        <p className="text-large-light text"><Translation id={textTransId} before={textBefore}/></p>

        <div className="buttons-submit-cancel">
            <Button
                className="button-submit"
                transId={primaryButtonTransId}
                onClick={onPrimary}
                disabled={false}
                hideText={false}
                type="button"
            />
            <Button
                className="button-submit"
                transId={secondaryButtonTransId}
                onClick={onSecondary}
                disabled={false}
                hideText={false}
                type="button"
            />
        </div>
    </OverlayWrapper>
)

export default OverlayTwoActionsComponent
